import { memo } from 'react';

import { RouterProvider, RouterProviderProps } from '@spazious/dollhouse-router';

import { AppProvider, AppProviderProps } from './AppProvider.js';

export interface AppProps<TCache = any> extends AppProviderProps<TCache> {
  router: RouterProviderProps['router'];
}

export const App = memo(<TCache,>({ router, ...restProps }: AppProps<TCache>) => {
  return (
    <AppProvider {...restProps}>
      <RouterProvider router={router} />
    </AppProvider>
  );
});
